import { useLayoutEffect } from 'react';

export default function useDisableUserSelect() {
  useLayoutEffect(() => {
    const style = document.createElement('style');

    if (!document) return;

    const head = document.querySelector('head');

    if (!head) return;

    style.innerHTML = `* {
      -webkit-user-select: none !important;  /* Chrome all / Safari all */
      -moz-user-select: none !important;     /* Firefox all */
      -ms-user-select: none !important;      /* IE 10+ */
      user-select: none !important;
    }`;

    head.appendChild(style);

    return () => {
      style.remove();
    };
  }, []);
}
